import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card-body p-9" }
const _hoisted_2 = {
  key: 0,
  class: "row mb-7"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Social security", -1)
const _hoisted_4 = { class: "col-lg-8 fv-row" }
const _hoisted_5 = { class: "row mb-7" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "SWIFT", -1)
const _hoisted_7 = { class: "col-lg-8 fv-row" }
const _hoisted_8 = { class: "row mb-7" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "IBAN", -1)
const _hoisted_10 = { class: "col-lg-8 fv-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$can('can_view_social_security_number', 'all') || _ctx.isAtOwnProfile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", {
              class: _normalizeClass(["fw-bold fs-6", 
            _ctx.getSingleUser.payment_settings.social_security ? '' : 'text-muted'
          ])
            }, _toDisplayString(_ctx.getSingleUser.payment_settings.social_security
              ? _ctx.getSingleUser.payment_settings.social_security
              : "No data"), 3)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", {
          class: _normalizeClass(["fw-bold fs-6", _ctx.getSingleUser.payment_settings.swift ? '' : 'text-muted'])
        }, _toDisplayString(_ctx.getSingleUser.payment_settings.swift
              ? _ctx.getSingleUser.payment_settings.swift
              : "No data"), 3)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("span", {
          class: _normalizeClass(["fw-bold fs-6", _ctx.getSingleUser.payment_settings.iban ? '' : 'text-muted'])
        }, _toDisplayString(_ctx.getSingleUser.payment_settings.iban
              ? _ctx.getSingleUser.payment_settings.iban
              : "No data"), 3)
      ])
    ])
  ]))
}